import { create } from "zustand"

export const useTreatmentTechniqueStore = create((set) => ({
  clickedArea: null,
  clickedPosition: null,
  clickedPoint3D: null,
  selectedTechniques: [],
  techniquesModeActive: false,
  appendAreasMode: false,

  setClickedArea: (name, position = null, point3D = null) => set({ clickedArea: name, clickedPosition: position, clickedPoint3D: point3D }),
  clearClickedArea: () => set({ clickedArea: null, clickedPosition: null, clickedPoint3D: null, appendAreasMode: false }),

  setTechniquesModeActive: (active) => set({ techniquesModeActive: active }),
  setAppendAreasMode: (active) => set({ appendAreasMode: active }),

  addSelectedTechnique: ({ areaName, label, output }) =>
    set((state) => ({
      selectedTechniques: [
        ...state.selectedTechniques,
        { areaName, label, output },
      ],
    })),

  removeSelectedTechnique: ({ areaName, label }) =>
    set((state) => ({
      selectedTechniques: state.selectedTechniques.filter(
        (s) => !(s.areaName === areaName && s.label === label)
      ),
    })),

  clearSelectedTechniques: () =>
    set({ selectedTechniques: [], clickedArea: null, clickedPoint3D: null, techniquesModeActive: false, appendAreasMode: false }),
}))
